// const domain = process.env.REACT_APP_DOMAIN;
// const node_domain = process.env.REACT_APP_NODE_DOMAIN
const domain = process.env.REACT_APP_DOMAIN;

export const LOGIN_API = `${domain}/api/admin/login`;
export const USER_API = `${domain}/api/admin/users`;
export const USER_INFO_API = `${domain}/api/admin/users`;
export const USER_BETS_API = `${domain}/api/admin/bets`;
export const SETTINGS_API = `${domain}/api/settings`;
export const SETTINGS_CUD_API = `${domain}/api/admin/settings`;
export const USER_TRANSACTION_API = `${domain}/api/admin/transactions`;
export const PAYMENT_PROVIDERS_API = `${domain}/api/admin/payment-providers`;
export const PAYMENT_PROVIDERS_CUD_API = `${domain}/api/admin/payment-providers`;
export const WINNERS_API = `${domain}/api/admin/winners`;
export const BET_STATS_API = `${domain}/api/bet-stats/previous`;
export const RESULTS_API = `${domain}/api/admin/results`;
export const DEPOSITS_API = `${domain}/api/admin/cash-in`;
export const DEPOSITS_CONFIRM_API = `${domain}/api/admin/cash-in-confirm`;
export const CASH_OUTS_API = `${domain}/api/admin/cash-out`;
export const CASH_OUTS_CONFIRM_API = `${domain}/api/admin/cash-out-confirm`;
export const CHANGE_PASSWORD_API = `${domain}/api/change-password`;
export const ADMIN_DASHBOARD_API = `${domain}/api/admin/dashboard`;
export const USER_REPORT_API = `${domain}/api/admin/user-reports`;
export const PAYMENT_REPORT_API = `${domain}/api/admin/payment-reports`;
export const DEPOSIT_WITHDRAW_REPORT_API = `${domain}/api/admin/deposit-withdraw-reports`;
export const SESSION_REPORT_API = `${domain}/api/admin/session-reports`;

// for proxy
export const IMAGE_PROXY_API = (name) => `${domain}/api/proxy/image/${name}`;
